import React, { useState } from "react";
import { Input, Button, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  FilterDropdownProps,
  FilterType,
  SelectOption,
} from "types/table.types";

interface ExtendedFilterDropdownProps extends FilterDropdownProps {
  filterType?: FilterType;
  filterOptions?: SelectOption[];
}

const FilterDropdown: React.FC<ExtendedFilterDropdownProps> = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  close,
  filterType = FilterType.SEARCH,
  filterOptions = [],
}) => {
  const [searchValue, setSearchValue] = useState<string>(
    (selectedKeys[0] as string) || ""
  );
  const [checkboxValues, setCheckboxValues] = useState<(string | number)[]>(
    filterType === FilterType.SELECT || filterType === FilterType.MULTI_SELECT
      ? (selectedKeys as (string | number)[])
      : []
  );

  const handleSearch = () => {
    if (filterType === FilterType.SEARCH) {
      setSelectedKeys(searchValue ? [searchValue] : []);
    } else {
      setSelectedKeys(checkboxValues.length > 0 ? checkboxValues : []);
    }
    confirm();
  };

  const handleReset = () => {
    setSearchValue("");
    setCheckboxValues([]);
    setSelectedKeys([]);
    clearFilters?.();
    confirm();
  };

  const handleCheckboxChange = (value: string | number, checked: boolean) => {
    if (filterType === FilterType.SELECT) {
      // Single select
      setCheckboxValues(checked ? [value] : []);
    } else {
      // Multi select
      setCheckboxValues((prev) =>
        checked ? [...prev, value] : prev.filter((v) => v !== value)
      );
    }
  };

  const renderFilterInput = () => {
    switch (filterType) {
      case FilterType.SELECT:
      case FilterType.MULTI_SELECT:
        return (
          <div className="mb-2 max-h-[300px] overflow-y-auto">
            {filterOptions.map((option) => (
              <div key={option.value} className="py-1">
                <Checkbox
                  checked={checkboxValues.includes(option.value)}
                  onChange={(e) =>
                    handleCheckboxChange(option.value, e.target.checked)
                  }
                >
                  {option.label}
                </Checkbox>
              </div>
            ))}
          </div>
        );
      case FilterType.SEARCH:
      default:
        return (
          <Input
            placeholder="Tìm kiếm..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onPressEnter={handleSearch}
            prefix={<SearchOutlined />}
            className="mb-2"
          />
        );
    }
  };

  return (
    <div className="p-2" style={{ width: 250 }}>
      {renderFilterInput()}
      <div className="w-full justify-end flex gap-2">
        <Button
          size="small"
          onClick={close}
          className="flex-1 w-full rounded-full"
        >
          Đóng
        </Button>
        <Button
          onClick={handleReset}
          size="small"
          className="flex-1 w-full rounded-full"
        >
          Reset
        </Button>
        <Button
          type="primary"
          onClick={handleSearch}
          size="small"
          className="flex-1 w-full rounded-full"
        >
          {filterType === FilterType.SEARCH ? "Tìm kiếm" : "Lọc"}
        </Button>
      </div>
    </div>
  );
};

export default FilterDropdown;
